export default {
  methods: {
    formatBasicText(text) {
      if (!text) {
        return '';
      }

      const lines = text.split(/\r\n|\r|\n/);
      const result = [];
      let currentList = null;
      let currentListType = '';
      let paragraphBuffer = [];

      /**
       * Closes the current list and adds it to the result array.
       */
      const closeList = () => {
        if (currentList && currentListType) {
          result.push(`<${currentListType}>${currentList.join('')}</${currentListType}>`);
          currentList = null;
          currentListType = '';
        }
      };

      /**
       * Flushes the paragraph buffer and adds it as a <p> tag to the result array.
       */
      const flushParagraph = () => {
        if (paragraphBuffer.length) {
          result.push(`<p>${paragraphBuffer.join('<br>')}</p>`);
          paragraphBuffer = [];
        }
      };

      lines.forEach(line => {
        const trimmedLine = line.trim();

        const orderedMatch = trimmedLine.match(/^(\d+)\.\s+(.*)/);
        const unorderedMatch = trimmedLine.match(/^[-*]\s+(.*)/);

        if (orderedMatch || unorderedMatch) {
          flushParagraph();

          const listItemContent = orderedMatch ? orderedMatch[2] : unorderedMatch[1];
          const newListType = orderedMatch ? 'ol' : 'ul';

          if (currentListType !== newListType) {
            closeList();
            currentList = [];
            currentListType = newListType;
          }
          currentList.push(`<li>${listItemContent}</li>`);
          return;
        }

        if (!trimmedLine) {
          closeList();
          flushParagraph();
          return;
        }

        closeList();
        paragraphBuffer.push(trimmedLine);
      });

      closeList();
      flushParagraph();

      return result.join('\n');
    }
  }
};
